var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('the-base-header',{on:{"gofoot":function($event){return _vm.gofoot()}}}),_c('div',[_c('router-view')],1),_c('the-base-footer',{attrs:{"id":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }